<template>
  <div>
    <div class="grid" v-if="availability.performance_review">
      <div class="flex flex-column col-8">
        <span> Performance Review </span
        ><span
          :style="{
            color: getStatus(performance_review).color
          }"
          >{{ getStatus(performance_review).title }}</span
        >
      </div>
      <div class="col-4 flex gap-1 justify-content-end">
        <a-button
          v-if="
            hasUncontrolledPermission('manage_associates', {
              id: associate.id
            })
          "
          size="small"
          title="Add Review"
          @click="handleDynamicView('performance_review')"
          icon="edit"
        />
        <export-button
          v-if="getStatus(performance_review).title === 'Actual'"
          :only-icon="true"
          :loading="loading.performance_review"
          @send="email => sendReport(email, 'performance_review')"
          @download="downloadReport('performance_review')"
        />
      </div>
    </div>
    <div class="grid" v-if="availability.skills_check">
      <div class="flex flex-column col-8">
        <span>Initial Skills Check </span
        ><span
          :style="{
            color: getStatus(skills_check).color
          }"
          >{{ getStatus(skills_check).title }}</span
        >
      </div>
      <div class="col-4 flex gap-1 justify-content-end">
        <a-button
          v-if="
            hasUncontrolledPermission('manage_associates', {
              id: associate.id
            })
          "
          size="small"
          title="Add Review"
          @click="handleDynamicView('skills_check')"
          icon="edit"
        />
        <export-button
          v-if="getStatus(skills_check).title === 'Actual'"
          :only-icon="true"
          :loading="loading.skills_check"
          @send="email => sendReport(email, 'skills_check')"
          @download="downloadReport('skills_check')"
        />
      </div>
    </div>
    <div class="grid" v-if="availability.annual_skills_check">
      <div class="flex flex-column col-8">
        <span> Annual Skills Check </span
        ><span
          :style="{
            color: getStatus(annual_skills_check).color
          }"
          >{{ getStatus(annual_skills_check).title }}</span
        >
      </div>
      <div class="col-4 flex gap-1 justify-content-end">
        <a-button
          v-if="
            hasUncontrolledPermission('manage_associates', {
              id: associate.id
            })
          "
          size="small"
          title="Add Review"
          @click="handleDynamicView('annual_skills_check')"
          icon="edit"
        />
        <export-button
          v-if="getStatus(annual_skills_check).title === 'Actual'"
          :only-icon="true"
          :loading="loading.annual_skills_check"
          @send="email => sendReport(email, 'annual_skills_check')"
          @download="downloadReport('annual_skills_check')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ExportButton from '@/components/export-button.vue'
import permissionMixin from '@/mixins/permissionMixin'
import util from '@/util'
import { Button, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapState: profileState, mapActions: profileActions } = createNamespacedHelpers('profile')
const { mapActions: documentActions, mapState: documentState } = createNamespacedHelpers('document')
const { mapActions: modalActions } = createNamespacedHelpers('modals')

export default {
  components: { 'a-button': Button, 'export-button': ExportButton },
  mixins: [permissionMixin],
  data() {
    return {
      loading: {}
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    }),
    ...documentState({
      skills_check: state => state.associateDynamicForm?.skills_check,
      annual_skills_check: state => state.associateDynamicForm?.annual_skills_check,
      performance_review: state => state.associateDynamicForm?.performance_review,
      associateDynamicForm: state => state.associateDynamicForm,
      availability: state => state.associateDynamicFormAvailability
    })
  },
  methods: {
    ...modalActions(['openModal']),
    ...profileActions(['sendExportedAssociate', 'downloadExportedAssociate']),
    ...documentActions(['setAssociateDynamicForm']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    getStatus(dynamic_form) {
      if (!dynamic_form) {
        return {
          title: 'Missing',
          color: '#ef4444'
        }
      } else if (dynamic_form.status === 'expired') {
        return {
          title: 'Expired',
          color: '#f59e0b'
        }
      } else if (dynamic_form.status === 'awaiting_signature') {
        return {
          title: 'Awaiting Signature',
          color: '#3b82f6'
        }
      } else {
        return {
          title: 'Actual',
          color: '#10b981'
        }
      }
    },

    handleDynamicView(type) {
      this.openModal({
        type: 'dynamicForm',
        data: {
          visible: true,
          type,
          initialValue: this.associateDynamicForm[type]
            ? {
                ...this.associateDynamicForm[type],
                associate_id: this.associate.id
              }
            : { associate_id: this.associate.id },
          save: data => {
            this.setAssociateDynamicForm({
              type,
              data
            })
          }
        }
      })
    },

    async sendReport(email, type) {
      this.$set(this.loading, type, true)

      const payload = {
        filters: { [type]: true },
        email: email.toLowerCase(),
        associate_id: this.associate.id
      }

      try {
        await this.sendExportedAssociate(payload)

        this.showNotification('success', 'Success', 'Document successfully sent to email')
      } catch (error) {
        this.showNotification('error', 'Error', error.message || error)
      } finally {
        this.$set(this.loading, type, false)
      }
    },

    async downloadReport(type) {
      this.$set(this.loading, type, true)

      const payload = {
        filters: { [type]: true },
        associate_id: this.associate.id
      }

      try {
        const url = await this.downloadExportedAssociate(payload)

        util.downloadFile(url)
      } catch (error) {
        this.showNotification('error', 'Error', error.message || error)
      } finally {
        this.$set(this.loading, type, false)
      }
    }
  }
}
</script>
